import { IJeopardy } from '../entities';

export interface IMaxDeferPaymentRequest {
  nextInvoicePaymentDue?: string;
  nextInvoiceOriginalPaymentDue?: string;
  followingInvoicePaymentDue?: string;
  policyTermEnd?: string;
  policyCancellationDate?: string;
}

export interface IMaxDeferPaymentDaysResponse {
  maxNumberOfDays: number;
}

export interface IDeferPaymentUpdateModel {
  userId?: string;
  d365Id?: string;
  newPaymentDate?: string;
  authorisedPolicyNumbers?: string[];
}

export interface ApplyRulesRequestOfDeferPaymentUpdateModel {
  quoteSessionId?: string;
  requestQuote?: boolean;
  bindChange?: boolean;
  model?: IDeferPaymentUpdateModel;
}

export interface IDeferPaymentViewModel {
  invoiceDeferredForPolcies: string[];
}

export interface ApplyRulesResponseOfDeferPaymentViewModel {
  jeopardies: IJeopardy[];
  viewModel: IDeferPaymentViewModel;
}

export interface IPaymentInstrument {
  paymentMethod: PaymentMethod;
  creditCardDetails: ICreditCardDetails;
  bankAccountDetails: IBankAccountDetails;
}

export interface ICreditCardDetails {
  cardType: string;
  token: string;
  maskedCardNumber: string;
  cardHolder: string;
  cardExpiry: string;
  cardVerification: string;
}

export interface IBankAccountDetails {
  bankStateBranchNumber: string;
  accountNumber: string;
  nameOfAccount: string;
  financialInstitutionName: string;
}

export enum PaymentMethod {
  CreditCard = 0,
  BankAccount = 1,
}
